import { StyledTruncatedTextTooltip } from '../Tooltip.styles';
import { ITooltip, ITooltipProps } from '../Tooltip';

export function TruncatedTextTooltip(props: ITooltipProps) {
  const { children } = props;
  return (
    <StyledTruncatedTextTooltip {...props} as={ITooltip}>
      {children}
    </StyledTruncatedTextTooltip>
  );
}
